
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import { isNullOrUndefined, isArray } from 'util';
    import { OpcionDeEnvioMercadoEnvios } from '@/__env/lib/MercadoLibre/Publicaciones/Publicacion.lib';

    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        public get EsEnvioGratis(): boolean
        {
            return this.Controlador.Seleccionada && this.Controlador.Seleccionada.Publicacion && this.Controlador.Seleccionada.Publicacion.EnvioGratis;
        }

        public get EsAcordar(): boolean
        {
            return this.Controlador.Seleccionada && this.Controlador.Seleccionada.Publicacion && this.Controlador.Seleccionada.Publicacion.ModoEnvio.esNoEspecificado;
        }
        public Cargando: boolean = false;
        public Opciones: OpcionDeEnvioMercadoEnvios[] = [];

        async mounted()
        {
            this.Controlador.BarraLateralWidth = 325;
        }

        public Origen: string = '1284';
        public Destino: string = '';
        public Estado: string = 'iniciado';

        public get Ok()
        {
            return !isNullOrUndefined( this.Destino ) && this.Destino && parseInt( this.Destino ) > 0;
        }

        async Buscar()
        {
            if ( !this.Destino )
            {
                return;
            }

            this.Estado = 'ok';
            this.Opciones.clear();
            this.Cargando = true;
            let e = await this.Controlador.Seleccionada.Publicacion.CalcularEnvio( this.Destino, this.Origen );
            if ( e && isArray( e.options ) && e.options.hasRows() )
            {
                for ( let op of e.options )
                {

                    let o = new OpcionDeEnvioMercadoEnvios( op );
                    if ( o.Costo.Importe > 0 )
                        this.Opciones.push( o );
                }
            }
            this.Cargando = false;
        }


        Utilizar( x: OpcionDeEnvioMercadoEnvios )
        {
            if ( this.Controlador.Seleccionada )
                this.Controlador.EnviarARespuesta( `El costo de envío a tu localidad ` + x.Formatear( this.Controlador.Seleccionada ) );
        }

        UtilizarTodo(  )
        {
            if ( this.Controlador.Seleccionada )
                this.Controlador.EnviarARespuesta( OpcionDeEnvioMercadoEnvios.Formatear( this.Opciones, this.Controlador.Seleccionada ) );
        }

        UtilizarEnvioGratis()
        {
            if ( this.Controlador.Seleccionada )
                this.Controlador.EnviarARespuesta( 'En este producto ofrecemos envios gratuitos!' );
        }


        Cerrar()
        {
            this.Controlador.Vista.Modo = 'respuestas';
        }

    }
